import { IconClassKey, StyleRules } from "@material-ui/core";
import { Shades } from "style/Colors";

export const MuiSvgIcon: Partial<StyleRules<IconClassKey, {}>> = {
  colorDisabled: {
    color: Shades.gray30,
  },
};
